import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { EventsService, GalleryService, UtilService } from '../../../../shared/services';
@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit, AfterViewInit {

  @Input() public documents;
  @Input() public sharedCounts;
  @Input() public fundraiser;
  @Input() public isFundraiserEnded;
  @Input() public basicInfo;
  @Input() position = '';
  defaultImg;

  constructor(
    private events: EventsService,
    public utilService: UtilService,
    private galleryService: GalleryService
  ) { }

  ngOnInit() {
    this.defaultImg = this.utilService.defaultImg;
  }
  ngAfterViewInit() {
    setTimeout(() => {
      this.galleryService.initGallery('lightgalleryDocs');
    }, 0);
  }

  imgClick(item) {
    const ePayload = {
      eventName: 'galary_img_click',
      info_1: this.position
    };
    this.events.sendSystemEvent(ePayload).subscribe(_ => _);
  }
}
